module.exports = __webpack_public_path__ + "assets/f181c56168e8fb9078a2c982dfb6f33d.png";